import React from "react";
import { useTableContext } from "../../components/AdministrateTable";
import { AdministrateResourceDeleteButton } from "../../components/AdministrateResourceDeleteButton";
import { useDestroyPermission } from "../../utils";

export const PortalCodeGroupActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const [canDestroy] = useDestroyPermission("BenefitManagementPortalCodeGroup", row.original.id);

  return (
    canDestroy && (
      <AdministrateResourceDeleteButton
        deleteUrl={`/admin/benefit_management_portal_code_groups/${row.original.id}`}
        onSuccess={() => {
          refresh();
          setMessage(`Removed Code Group ${row.original.codeGroup?.name}`);
        }}
        onError={(msg) => setError(msg)}
      />
    )
  );
};
